import { Moment } from 'moment';

import { User, UserEmail, UserSession, UniverseReference, OAuthLoginData, DeviceDetails } from '../types/commons';
import { formatDate, FORMATS } from '../utils/date';

import { get, post, put, del } from './requester';

export const universes = {
  get: () => get('/universes', { query: { with_disabled: 1 } }),
  getUniverseAtTime: (universeReference: UniverseReference, date: Moment) => {
    const dateString = formatDate(date, FORMATS.DATE.ISO_8601);
    return get(`/universes/${universeReference}/at/${dateString}`);
  },
};

export const user = {
  get: () => get('/user'),
  create: (value: Partial<User>) => post('/user', { skipJsonParsing: true, body: { user: value } }),
  update: (value: Partial<User & DeviceDetails>) => put('/user', { body: { user: value } }),
  delete: () => del('/user'),
  emailExists: (value: UserEmail) => post('/user/email_exists', { body: { user: value } }),
  oauthConnect: (authData: OAuthLoginData, userData?: User) =>
    post('/user/create_with_token', {
      skipJsonParsing: true,
      body: {
        omniauth: {
          provider: authData.provider,
          access_token: authData.accessToken,
          uid: authData.userID,
        },
        user: userData,
      },
    }),
};

export const session = {
  create: (value: UserSession) => post('/session', { skipJsonParsing: true, body: { user: value } }),
  del: () => del('/session'),
};

export const password = {
  create: (value: UserEmail) => post('/passwords', { body: { user: value } }),
};

export const config = {
  get: () => get('/config'),
};

export const nps = {
  create: (score: number, comment?: string) => post('/net_promoter_scores', { body: { score, comment } }),
};
